var _circle, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayroll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "black",
    fillOpacity: 0.12
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    fill: "#39BAB5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 6.25H15.115C14.8 5.38 13.975 4.75 13 4.75C12.025 4.75 11.2 5.38 10.885 6.25H7.75C6.925 6.25 6.25 6.925 6.25 7.75V18.25C6.25 19.075 6.925 19.75 7.75 19.75H18.25C19.075 19.75 19.75 19.075 19.75 18.25V7.75C19.75 6.925 19.075 6.25 18.25 6.25ZM13 6.25C13.4125 6.25 13.75 6.5875 13.75 7C13.75 7.4125 13.4125 7.75 13 7.75C12.5875 7.75 12.25 7.4125 12.25 7C12.25 6.5875 12.5875 6.25 13 6.25ZM13 9.25C14.245 9.25 15.25 10.255 15.25 11.5C15.25 12.745 14.245 13.75 13 13.75C11.755 13.75 10.75 12.745 10.75 11.5C10.75 10.255 11.755 9.25 13 9.25ZM17.5 18.25H8.5V17.2C8.5 15.7 11.5 14.875 13 14.875C14.5 14.875 17.5 15.7 17.5 17.2V18.25Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayroll);
export default __webpack_public_path__ + "static/media/payroll.e20ee5d8322dcf77cb0cba08d24c555c.svg";
export { ForwardRef as ReactComponent };